import type { NativeEmbedFeature } from '../../../../common/types/features/main';

/**
 * <<Data structure>>
 *
 * A class that holds the supported features for a given client.
 * Supports the deferred nature of the feature handshake whilst initializing the client.
 */
export class SupportedFeatures {
	private localSupportedFeatures: Set<NativeEmbedFeature>;
	private readonly deferred: SupportedFeaturesDeferred;

	constructor(localSupportedFeatures: Set<NativeEmbedFeature> = new Set()) {
		this.localSupportedFeatures = localSupportedFeatures;
		this.deferred = {} as SupportedFeaturesDeferred;
		this.deferred.promise = new Promise((resolve) => {
			this.deferred!.resolve = resolve;
		});
	}

	setLocalSupportedFeatures(features: Set<NativeEmbedFeature>): void {
		this.localSupportedFeatures = features;
	}

	getLocalSupportedFeatures(): Set<NativeEmbedFeature> {
		return this.localSupportedFeatures;
	}

	getFeaturesPromise(): Promise<Set<NativeEmbedFeature>> {
		return this.deferred.promise;
	}

	/**
	 * Completes the handshake with the agreed feature set (call from host after computing intersection, or from child when host responds).
	 */
	completeWithAgreedFeatures(agreed: Set<NativeEmbedFeature>): void {
		this.deferred.resolve(agreed);
	}
}

interface SupportedFeaturesDeferred {
	promise: Promise<Set<NativeEmbedFeature>>;
	resolve: (value: Set<NativeEmbedFeature>) => void;
}
